module.exports = __webpack_public_path__ + "img/03.274c58a1.png";